/** Public product identity. MLS Ingest is the brand; Brokurz is the parent. */

export const PRODUCT_NAME = 'MLS Ingest'
export const PRODUCT_DOMAIN = 'mlsingest.com'
export const PRODUCT_WORDMARK = 'MLS Ingest'
export const PRODUCT_MARK = 'MLS'
export const PARENT_NAME = 'Brokurz'
export const PARENT_LOCKUP = 'Brokurz'
export const PARENT_COMPANY_LINE = 'a Brokurz company'
export const PARENT_URL = 'https://brokurz.com'
export const CONNECT_MLS_URL = 'https://brokurz.com/get-started'
export const CONTACT_EMAIL = 'hello@mlsingest.com'
export const PRODUCT_TAGLINE = 'The AI infrastructure behind real estate search.'
